import { ECreditApplicationStep, EDecision } from '@if/core/types'
import { FilteredCreditApplication } from '@src/api/credit-api'
import { ErrorPage } from '@src/components'
import { hasMissingDocuments, mustAskCoapplicantSIN } from '@src/data/credit-application-selectors'
import DecisionningErrorTile from '../components/DecisionningErrorTile'
import DeclinedDecisionForm from '../components/DeclinedDecisionForm'
import UnderReviewTile from '../components/UnderReviewTile'
import FailedToObtainCreditReportForm from '../PrequalResultPage/components/FailedToObtainCreditReportForm'
import CoappSinForm from './components/CoappSinForm'
import CreditFileLockedTile from './components/CreditFileLockedTile'
import RequiredDocForDecisionForm from './components/RequiredDocForDecisionForm'

interface Props {
  creditApp: FilteredCreditApplication
}

const HardHitUnapprovedResultPage = ({ creditApp }: Props) => {
  const requiresCoappSin = mustAskCoapplicantSIN(creditApp)

  const hasMissingDocForCreditDecision = hasMissingDocuments(creditApp, ECreditApplicationStep.Credit)

  if (creditApp.applicant.hasLockedCreditReport || creditApp.coapplicant?.hasLockedCreditReport === true)
    return <CreditFileLockedTile creditApp={creditApp} />

  if (creditApp.coapplicant && !creditApp.coapplicant.hasCreditReport)
    return <FailedToObtainCreditReportForm creditApp={creditApp} />
  if (
    creditApp.finalDecision.decision === EDecision.Error ||
    (!creditApp.applicant.hasCreditReport && !creditApp.coapplicant?.hasCreditReport)
  )
    return <DecisionningErrorTile />

  if (creditApp.finalDecision.decision === EDecision.Refused) return <DeclinedDecisionForm creditApp={creditApp} />

  if (requiresCoappSin) return <CoappSinForm creditApp={creditApp} />

  if (creditApp.finalDecision.decision === EDecision.ManualRevision && !hasMissingDocForCreditDecision)
    return <UnderReviewTile />

  if (creditApp.finalDecision.decision === EDecision.ManualRevision && hasMissingDocForCreditDecision)
    return <RequiredDocForDecisionForm creditApp={creditApp} />

  return <ErrorPage />
}

export default HardHitUnapprovedResultPage
